// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItem_item__0e336","activatable":"MenuItem_activatable__a5dad","active":"MenuItem_active__276ce"};